import React from 'react'

import { styled } from '~/styled'

export const StyledDivider = styled(
  'hr',
  {
    base: ['border-none', 'bg-grey-200'],
    variants: {
      orientation: {
        horizontal: ['h-px', 'w-full'],
        vertical: ['h-full', 'min-h-8', 'w-px']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

export const Divider = React.forwardRef<
  HTMLHRElement,
  React.ComponentProps<typeof StyledDivider>
>(({ orientation = 'horizontal', ...rest }, ref) => {
  return <StyledDivider ref={ref} orientation={orientation} {...rest} />
})
